import fetch from '@/utils/fetch';
import * as API from '@/commons/http-api';

/**
 * 示例模块
 */
export default {
  namespace: 'addressModal',
  state: {
    provList: [],
    branchList: [],
  },
  reducers: {
    setDataSource(state, action) {
      return {
        ...state,
        provList: action.payload,
      };
    },
    setBranchList(state, action) {
      return {
        ...state,
        branchList: action.payload,
      };
    },
  },
  effects: {
    *getProvDataSource(action, { put }) {
      const res = yield fetch.get(API.ADDRESS_PROV);
      yield put({
        type: 'setDataSource',
        payload: res.data || [],
      });
    },
    *getCityDataSource(action, { put }) {
      const { paramsId, callback = () => {} } = action.payload;
      const res = yield fetch.get(API.ADDRESS_CITY + paramsId);
      if (res.errorType && res.errorType === 'ERROR') {
      } else {
        yield put({
          type: 'setDataSource',
          payload: res.data || [],
        });
        if (callback && typeof callback === 'function') {
          callback();
        }
      }
    },
    *getCountryDataSource(action, { put }) {
      const { paramsId, callback = () => {} } = action.payload;
      const res = yield fetch.get(API.ADDRESS_COUNTRY + paramsId);
      if (res.errorType && res.errorType === 'ERROR') {
      } else {
        yield put({
          type: 'setDataSource',
          payload: res.data || [],
        });
        if (callback && typeof callback === 'function') {
          console.log(res);
          if (res.data.length === 0) {
            callback(true);
          } else {
            callback();
          }
        }
      }
    },
    *getBranchList(action, { put }) {
      const { callback = () => {} } = action.payload;
      const res = yield fetch.post(API.GET_BRANCH_LIST);
      if (res.errorType && res.errorType === 'ERROR') {
      } else {
        yield put({
          type: 'setBranchList',
          payload: res.data || [],
        });
        if (callback && typeof callback === 'function') {
          callback(res.data || []);
        }
      }
    },
  },
};
